export default {
  SOURCE_CAMERA: 'Camera',
  SOURCE_GALLERY: 'Gallery',
};
